import API from "./api"

const api = new API()

export { api }
